<!-- no profile selected -->
@if (profile_id() === '') {
<div class="container container-profile container-profile-company">
  @if (selectableProfiles().length > 0) {
  <div class="page-header">
    <h1 class="page-title">
      {{'Choose profile to edit' | translate}}
    </h1>
  </div>

  <div class="d-flex justify-content-center">
    @for (profile of selectableProfiles(); track profile.id) {
    <a class="btn btn-primary mr-3" [routerLink]="'/company/profile/' + profile.id">
      {{profile.name}}
    </a>
    }
  </div>
  }
</div>
}

<!-- profile id selected -->
@if (profile_id() !== '') {
<div class="container container-profile container-profile-company">
  @if (isLoading()) {
  <app-loader></app-loader>
  }

  @if (!isLoading()) {
  <div class="company-profile">
    @if (elections().length > 0) {
    <div class="alert alert-info mt-2 d-none">
      <p class="m-0 p-0 text-center">
        {{ 'There are currently elections to sign up for!' | translate }}
        <a (click)="showElections()" class="font-weight-bold cursor-pointer">{{ 'Show me!' | translate }}</a>
      </p>
    </div>
    }

    <!-- cover -->
    <div class="container-fluid container-cover-wrapper">
      <div class="editable-group">
        <div class="edit-icon">
          <fa-icon [icon]="faEdit" (click)="editCover()"></fa-icon>
        </div>
      </div>

      <div class="container-cover">
        <div class="ovaalcontainer2">
          <div class="row">
            <div class="cover-photo" [ngStyle]="{'background-image': 'url(' + entity().coverPhotoUri + ')'}"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- content -->
    <div class="container-fluid container-content">
      <div class="content-wrapper">
        <div class="row">
          <div class="sidebar sidebar-left col-12 col-sm-3">
            <div class="content">
              <!-- profile logo  -->
              <div class="card mb-3">
                <div class="card-body">
                  <div class="company-logo">
                    <div class="editable-group">
                      <div class="edit-icon">
                        <fa-icon [icon]="faEdit" (click)="editAvatar()"></fa-icon>
                      </div>
                    </div>

                    <div class="circle">
                      @if (entity().avatarUri) {
                      <img class="image logo-image" [src]="entity().avatarUri" />
                      }
                    </div>
                  </div>

                  <div class="company-info">
                    <div class="h2 company-name">
                      {{entity().name}}
                    </div>

                    @if (entity().visitAddress.city) {
                    <div class="location text-center mb-3">
                      <fa-icon [icon]="faMapMarkerAlt"></fa-icon> {{entity().visitAddress.city}}
                    </div>
                    }

                    <div class="company-sector">
                      <p>
                        <span class="text-primary">{{'Sector' | translate}}:</span>
                        <br>
                        {{interestService.getAreaOfInterestName(entity().sectorId ?? null, areaOfInterests()) | translate}}
                      </p>
                    </div>

                    @if ((entity().areaOfInterests?.length ?? 0) > 0) {
                    <div class="company-areaofinterests">
                      <p>
                        <span class="text-primary">{{'Field of interest' | translate}}:</span>
                        <br>
                        @for (interest of entity().areaOfInterests; track interest.id; let key = $index) {
                        <span>
                          {{interestService.getAreaOfInterestName(interest.id ?? null, areaOfInterests())}}{{(key === (entity().areaOfInterests?.length ?? 0) - 1) ? '' : ','}}
                        </span>
                        }
                      </p>
                    </div>
                    }

                    @if (entity().numberOfEmployees) {
                    <div class="company-employees">
                      <p>
                        <span class="text-primary">{{'Employees' | translate}}:</span>
                        <br>
                        {{entity().numberOfEmployees}}
                      </p>
                    </div>
                    }
                  </div>
                </div>
              </div>

              <!-- navigation -->
              <div class="card">
                <div class="card-body p-0">
                  <ul class="nav flex-column">
                    <li class="nav-item">
                      <a class="nav-link cursor-pointer" [class.active]="activeTab() === 'story'" (click)="selectTab('story')">
                        {{'Story' | translate}}
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link cursor-pointer" [class.active]="activeTab() === 'jobs'" (click)="selectTab('jobs')">
                        {{'Jobs' | translate}}
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link cursor-pointer" [class.active]="activeTab() === 'assignments'" (click)="selectTab('assignments')">
                        {{'Assignments' | translate}}
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link cursor-pointer" [class.active]="activeTab() === 'matchcriteria'" (click)="selectTab('matchcriteria')">
                        {{'Match criteria' | translate}}
                      </a>
                      <ul class="dropdown-submenu">
                        <li class="nav-item">
                          <a class="nav-link cursor-pointer" [class.active]="activeTab() === 'matchcriteria' && activeMatchcriteriaTab() === 'matches'" (click)="showMatchesTab();">
                            {{ 'Matches' | translate}}
                          </a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link cursor-pointer" [class.active]="activeTab() === 'matchcriteria' && activeMatchcriteriaTab() === 'internationals'" (click)="showInternationalsTab();">
                            {{ 'Internationals' | translate}}
                          </a>
                        </li>
                      </ul>
                    </li>
                    @if (isDNAEnabled) {
                    <li class="nav-item d-none">
                      <a class="nav-link cursor-pointer" [class.active]="activeTab() === 'dna'" (click)="selectTab('dna')">
                        {{'DNA' | translate}}
                      </a>
                    </li>
                    }

                    <li class="nav-item">
                      <a class="nav-link cursor-pointer" [class.active]="activeTab() === 'experienceday'" (click)="selectTab('experienceday')">
                        {{'Follow-up days' | translate}}
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link cursor-pointer" [class.active]="activeTab() === 'meetday-scans'" (click)="selectTab('meetday-scans')">
                        {{'Meetday scans' | translate}}
                      </a>
                    </li>

                    @if (elections().length > 0) {
                    <li class="nav-item">
                      <a class="nav-link cursor-pointer" [class.active]="activeTab() === 'elections'" (click)="selectTab('elections')">
                        {{'Elections' | translate}}
                      </a>
                    </li>
                    }

                    <li class="nav-item">
                      <a class="nav-link cursor-pointer" [class.active]="activeTab() === 'tradenames'" (click)="selectTab('tradenames')">
                        {{'Trade names' | translate}}
                      </a>
                    </li>

                    <li class="nav-item">
                      <a class="nav-link cursor-pointer" [class.active]="activeTab() === 'contact'" (click)="selectTab('contact')">
                        {{'Contact' | translate}}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-9 main-content">
            <div class="btn-toolbar">
              <a class="btn btn-primary ml-auto" target="_blank" [routerLink]=" '/companies/' + entity().id">
                <fa-icon [icon]="faEye"></fa-icon> {{'View public profile' | translate}}
              </a>
            </div>

            <div class="tab-content mt-4">
              <!-- tab story -->
              <div id="tab-profile-story" class="tab-pane" [class.active]="activeTab() === 'story'" [class.d-none]="activeTab() !== 'story'">
                <!-- toolbar actions -->
                <div class="btn-toolbar justify-content-between">
                  <button class="btn btn-primary ml-auto" (click)="UpdateCompanyProfile()">
                    <fa-icon [icon]="faSave"></fa-icon> {{'Save' | translate}}
                  </button>
                </div>

                <h3 class="tab-title">{{'Story' | translate}} {{entity().name}}</h3>

                <!-- Formly-based translatable editor fields -->
                <div class="flex flex-col gap-5">
                  <formly-form [form]="storyForm" [fields]="storyFields" [model]="entity()">
                  </formly-form>
                </div>

                <!-- toolbar actions -->
                <div class="btn-toolbar justify-content-between">
                  <button class="btn btn-primary ml-auto" (click)="UpdateCompanyProfile()">
                    <fa-icon [icon]="faSave"></fa-icon> {{'Save' | translate}}
                  </button>
                </div>

                <!-- photos -->
                <div class="entity-profile-photos company-photos">
                  <h3>{{'Photos' | translate}}</h3>

                  <div class="editable-group">
                    <div class="edit-icon">
                      <fa-icon [icon]="faEdit" (click)="editPhotos()"></fa-icon>
                    </div>
                  </div>

                  @if (companyPhotos.length > 0) {
                  <ngb-carousel [showNavigationArrows]="true" [showNavigationIndicators]="true">
                    @for (slide of companyPhotos; track slide.imageUri) {
                    <ng-template ngbSlide>
                      <div class="slide-item flex-grow-1">
                        <div class="slide-item-wrapper" [ngStyle]="{'background-image' : 'url(' + slide['imageUri'] + ')'}">
                        </div>
                      </div>
                    </ng-template>
                    }
                  </ngb-carousel>
                  }
                </div>

                <!-- videos -->
                <div class="entity-profile-videos company-videos">
                  <h3>{{'Videos' | translate}}</h3>

                  <div class="editable-group">
                    <div class="edit-icon">
                      <fa-icon [icon]="faEdit" (click)="editVideos()"></fa-icon>
                    </div>
                  </div>

                  @if (companyVideos.length > 0) {
                  <ngb-carousel [showNavigationArrows]="true" [showNavigationIndicators]="true">
                    @for (slide of companyVideos; track $index) {
                    <ng-template ngbSlide>
                      <div class="slide-item flex-grow-1">
                        <a class="link-video cursor-pointer" (click)="videoService.openVideo(slide['youtubeUri'])">
                          <div class="slide-item-wrapper" [ngStyle]="{'background-image' : 'url(' + slide['youtubeImageUri'] + ')'}">
                          </div>
                        </a>
                      </div>
                    </ng-template>
                    }
                  </ngb-carousel>
                  }
                </div>
              </div>

              <!-- tab jobs -->
              <div id="tab-profile-jobs" class="tab-pane" [class.active]="activeTab() === 'jobs'" [class.d-none]="activeTab() !== 'jobs'">
                <h3 class="tab-title">{{'Jobs' | translate}}</h3>

                <div class="btn-toolbar view-filter-toolbar-top mb-4">
                  <!-- sorting -->
                  <div class="input-group flex-grow-1">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        {{'Sort on' | translate}}
                      </span>
                    </div>
                    <select class="form-control custom-select" [ngModel]="jobsOrderby()" (ngModelChange)="jobsOrderby.set($event); applySortCompanyJobPostings()">
                      @for (option of orderByOptions; track option.value) {
                      <option [value]="option.value">
                        {{option.label | translate}}
                      </option>
                      }
                    </select>
                    <select class="form-control custom-select" [ngModel]="jobsOrder()" (ngModelChange)="jobsOrder.set($event); applySortCompanyJobPostings()">
                      @for (option of orderOptions; track option.value) {
                      <option [value]="option.value">
                        {{option.label | translate}}
                      </option>
                      }
                    </select>
                  </div>

                  <!-- search -->
                  <div class="input-group ml-4">
                    <input (change)="applyFilterCompanyJobPostings()" [ngModel]="jobsFiltersSearch()" (ngModelChange)="jobsFiltersSearch.set($event)" type="text" [placeholder]="'Search by title...' | translate" class="form-control" />
                    <div class="input-group-append">
                      <button type="button" class="btn btn-primary" (click)="applyFilterCompanyJobPostings()">
                        <fa-icon [icon]="faSearch"></fa-icon>
                      </button>
                    </div>
                  </div>

                  <button class="btn btn-primary ml-3" (click)="addJobposting()">
                    <fa-icon [icon]="faPlus"></fa-icon> {{'Add' | translate}}
                  </button>
                </div>

                <div class="form-group">
                  @for (type of jobTypes; track type.value) {
                  <div class="custom-control custom-checkbox custom-control-inline">
                    <input [checked]="existJobpostingType(type.value)" type="checkbox" class="custom-control-input" />
                    <label class="custom-control-label" (click)="toggleJobpostingType(type.value)">{{type.label | translate}}</label>
                  </div>
                  }
                </div>

                <!-- results -->
                @if (jobsDataFiltered().length > 0) {
                <div class="jobs">
                  <div class="grid grid-jobs equal-height">
                    <div class="row">
                      @for (job of jobsDataFiltered(); track job.id) {
                      <div class="col-12 col-lg-4 col-md-6 col-sm-6">
                        <app-job-card (buttonEvent)="handleJobButtonEvent($event)" [isOwner]="true" [roleType]="RoleTypes.Company" [data]="job"></app-job-card>
                      </div>
                      }
                    </div>
                  </div>
                </div>
                }

                <!-- no results -->
                @if (jobsDataFiltered().length === 0 || jobsData().length === 0) {
                <div class="alert alert-info">
                  {{'No results' | translate}}
                </div>
                }
              </div>

              <!-- tab assignments -->
              <div id="tab-profile-assignments" class="tab-pane" [class.active]="activeTab() === 'assignments'" [class.d-none]="activeTab() !== 'assignments'">
                <h3 class="tab-title">{{'Assignments' | translate}}</h3>

                <div class="btn-toolbar view-filter-toolbar-top mb-4">
                  <!-- sorting -->
                  <div class="input-group flex-grow-1">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        {{'Sort on' | translate}}
                      </span>
                    </div>
                    <select class="form-control custom-select" [ngModel]="assignmentsOrderby()" (ngModelChange)="assignmentsOrderby.set($event); applySortCompanyAssignments()">
                      @for (option of orderByOptions; track option.value) {
                      <option [value]="option.value">
                        {{option.label | translate}}
                      </option>
                      }
                    </select>
                    <select class="form-control custom-select" [ngModel]="assignmentsOrder()" (ngModelChange)="assignmentsOrder.set($event); applySortCompanyAssignments()">
                      @for (option of orderOptions; track option.value) {
                      <option [value]="option.value">
                        {{option.label | translate}}
                      </option>
                      }
                    </select>
                  </div>

                  <!-- search -->
                  <div class="input-group ml-4">
                    <input (change)="applyFilterCompanyAssignments()" [ngModel]="assignmentsFiltersSearch()" (ngModelChange)="assignmentsFiltersSearch.set($event)" type="text" [placeholder]="'Search by title...' | translate" class="form-control" />
                    <div class="input-group-append">
                      <button type="button" class="btn btn-primary" (click)="applyFilterCompanyAssignments()">
                        <fa-icon [icon]="faSearch"></fa-icon>
                      </button>
                    </div>
                  </div>

                  <button class="btn btn-primary ml-3" (click)="addAssignment()">
                    <fa-icon [icon]="faPlus"></fa-icon> {{'Add' | translate}}
                  </button>
                </div>

                <!-- results -->
                @if (assignmentsDataFiltered().length > 0) {
                <div class="jobs">
                  <div class="grid grid-jobs equal-height">
                    <div class="row">
                      @for (job of assignmentsDataFiltered(); track job.id) {
                      <div class="col-12 col-lg-4 col-md-6 col-sm-6">
                        <app-job-card (buttonEvent)="handleAssignmentButtonEvent($event)" [isOwner]="true" [roleType]="RoleTypes.Company" [isAssignment]="true" [data]="job"></app-job-card>
                      </div>
                      }
                    </div>
                  </div>
                </div>
                }

                <!-- no results -->
                @if (assignmentsDataFiltered().length === 0 || assignmentsData().length === 0) {
                <div class="alert alert-info">
                  {{'No results' | translate}}
                </div>
                }
              </div>

              <!-- tab match criteria -->
              <div id="tab-profile-matchcriteria" class="tab-pane" [class.active]="activeTab() === 'matchcriteria'" [class.d-none]="activeTab() !== 'matchcriteria'">
                <h3 class="tab-title">{{'Match criteria' | translate}}</h3>

                <ul class="nav nav-tabs">
                  <li class="nav-item">
                    <a class="nav-link cursor-pointer" [class.active]="activeMatchcriteriaTab() === 'matchtest'" (click)="activeMatchcriteriaTab.set('matchtest')">
                      {{'Match test' | translate}}
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link cursor-pointer" [class.active]="activeMatchcriteriaTab() === 'matches'" (click)="activeMatchcriteriaTab.set('matches'); getMatches()">
                      {{'Matches' | translate}}
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link cursor-pointer" [class.active]="activeMatchcriteriaTab() === 'internationals'" (click)="activeMatchcriteriaTab.set('internationals'); getInternationalMatches()">
                      {{'Internationals' | translate}}
                    </a>
                  </li>
                </ul>

                <div class="tab-content">
                  <!-- tab match criteria match test -->
                  <div id="tab-matchcriteria-matchtest" class="tab-pane pt-3" [class.active]="activeMatchcriteriaTab() === 'matchtest'" [class.d-none]="activeMatchcriteriaTab() !== 'matchtest'">
                    <div class="alert alert-info">
                      <fa-icon [icon]="faInfoCircle"></fa-icon>
                      {{'If you update the match criteria it can take up one day to get the correct (re-)calculated match results.' | translate}}
                    </div>

                    <div>
                      <!-- toolbar actions -->
                      <div class="btn-toolbar">
                        <button class="btn btn-primary ml-auto" (click)="updateMatchcriteria()">
                          <fa-icon [icon]="faSave"></fa-icon> {{'Save' | translate}}
                        </button>
                      </div>

                      <!-- competencies wrapper -->
                      <div class="matchtest-competences-wrapper">
                        <!-- competencies -->
                        <div class="matchtest-competences-groups-wrapper">
                          <!-- company culture -->
                          <div class="matchtest-competence-group-wrapper">
                            <h3>{{'Company culture' | translate}}</h3>

                            <!-- factor company culture -->
                            <div class="form-group row">
                              <label class="col-form-label col-sm-12">{{'Weighting percentage' | translate}}</label>
                              <div class="col-12 col-sm-6">
                                <div class="input-group">
                                  <input class="form-control" type="number" (change)="onFactorChange('companyCultureFactor')" (keyup)="onFactorChange('companyCultureFactor')" [ngModel]="matchcriterion().companyCultureFactor" (ngModelChange)="updateMatchcriterionField('companyCultureFactor', $event)" />
                                  <div class="input-group-append">
                                    <span class="input-group-text">
                                      %
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- selectable competencies company culture -->
                            <div class="row">
                              <!-- selectable options go here -->
                              <div class="col-12 col-sm-6">
                                <p>{{'Select maximum 5 competences' | translate}}</p>

                                @for (competency of matchCompetencyCompanyCulture(); track competency.id; let cKey = $index) {
                                <!-- checkable option -->
                                <div class="custom-control custom-checkbox">
                                  <input type="checkbox" class="custom-control-input" [checked]="hasMatchtestCompetenceValue(competency.id!, 'companyCultureCompetencies')">
                                  <label class="custom-control-label" (click)="toggleMatchtestCompetence(competency.id!, 'companyCultureCompetencies')">
                                    {{competency.name | translate }}
                                  </label>
                                </div>
                                }
                              </div>

                              <!-- selected values go here -->
                              <div class="col-12 col-sm-6">
                                <p>
                                  {{'Sort the selected competences based on priority' | translate}}
                                </p>

                                <ul class="list-group">
                                  @for (competencyMatchcriterion of matchcriterion().companyCultureCompetencies; track competencyMatchcriterion.matchCompetencyId; let key = $index) {
                                  <li class="list-group-item d-flex flex-row justify-content-between">
                                    <span class="text">
                                      {{key + 1}}.
                                      {{(competencyMatchcriterion.name || '') | translate }}
                                    </span>
                                    <div class="btn-group">
                                      <button class="btn btn-sm btn-outline-secondary" (click)="moveMatchcriterionCompetencyUp(key, 'companyCultureCompetencies')">
                                        <fa-icon [icon]="faChevronUp"></fa-icon>
                                      </button>
                                      <button class="btn btn-sm btn-outline-secondary" (click)="moveMatchcriterionCompetencyDown(key, 'companyCultureCompetencies')">
                                        <fa-icon [icon]="faChevronDown"></fa-icon>
                                      </button>
                                    </div>
                                  </li>
                                  }
                                </ul>
                              </div>
                            </div>
                          </div>

                          <!-- personality culture -->
                          <div class="matchtest-competence-group-wrapper mt-3">
                            <h3>{{'Personality traits' | translate}}</h3>

                            <!-- factor personality -->
                            <div class="form-group row">
                              <label class="col-form-label col-sm-12">{{'Weighting percentage' | translate}}</label>
                              <div class="col-12 col-sm-6">
                                <div class="input-group">
                                  <input class="form-control" type="number" (change)="onFactorChange('personalityFactor')" (keyup)="onFactorChange('personalityFactor')" [ngModel]="matchcriterion().personalityFactor" (ngModelChange)="updateMatchcriterionField('personalityFactor', $event)" />
                                  <div class="input-group-append">
                                    <span class="input-group-text">
                                      %
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- selectable competencies personality -->
                            <div class="row">
                              <!-- selectable options go here -->
                              <div class="col-12 col-sm-6">
                                <p>{{'Select maximum 2 competences' | translate}}</p>

                                @for (competency of matchCompetencyPersonality(); track competency.id; let cKey = $index) {
                                <!-- checkable option -->
                                <div class="custom-control custom-checkbox">
                                  <input type="checkbox" class="custom-control-input" [checked]="hasMatchtestCompetenceValue(competency.id!, 'personalityCompetencies')">
                                  <label class="custom-control-label" (click)="toggleMatchtestCompetence(competency.id!, 'personalityCompetencies')">
                                    {{competency.name | translate }}
                                  </label>
                                </div>
                                }
                              </div>

                              <!-- selected values go here -->
                              <div class="col-12 col-sm-6">
                                <p>
                                  {{'Sort the selected competences based on priority' | translate}}
                                </p>

                                <ul class="list-group">
                                  @for (competencyMatchcriterion of matchcriterion().personalityCompetencies; track competencyMatchcriterion.matchCompetencyId; let key = $index) {
                                  <li class="list-group-item d-flex flex-row justify-content-between">
                                    <span class="text">
                                      {{key + 1}}.
                                      {{(competencyMatchcriterion.name || '') | translate }}
                                    </span>
                                    <div class="btn-group">
                                      <button class="btn btn-sm btn-outline-secondary" (click)="moveMatchcriterionCompetencyUp(key, 'personalityCompetencies')">
                                        <fa-icon [icon]="faChevronUp"></fa-icon>
                                      </button>
                                      <button class="btn btn-sm btn-outline-secondary" (click)="moveMatchcriterionCompetencyDown(key, 'personalityCompetencies')">
                                        <fa-icon [icon]="faChevronDown"></fa-icon>
                                      </button>
                                    </div>
                                  </li>
                                  }
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- field of interest -->
                      @if (areaOfInterests().length > 0) {
                      <div class="matchtest-interests mt-4">
                        <h3>{{'Field of interest' | translate}}</h3>

                        <div class="form-group row">
                          <label class="col-form-label col-12">{{'Weighting percentage' | translate}}</label>
                          <div class="col-12 col-sm-6">
                            <div class="input-group">
                              <input class="form-control" type="number" (change)="onFactorChange('areaOfInterestFactor')" (keyup)="onFactorChange('areaOfInterestFactor')" [ngModel]="matchcriterion().areaOfInterestFactor" (ngModelChange)="updateMatchcriterionField('areaOfInterestFactor', $event)" />
                              <div class="input-group-append">
                                <span class="input-group-text">%</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="entity-areaofinterests">
                          <app-selector-areaofinterests [maxAmount]="15" [ngModel]="entity().areaOfInterests" (ngModelChange)="updateEntityField('areaOfInterests', $event)" [data]="areaOfInterests()"></app-selector-areaofinterests>
                        </div>
                      </div>
                      }

                      <!-- education levels -->
                      <div class="matchtest-educationlevel mt-4">
                        <h3>{{'Education levels' | translate}}</h3>

                        <formly-form
                          [model]="eduLevelsModel"
                          [fields]="eduLevelFields"
                          [form]="eduLevelsForm"
                          (modelChange)="onEduLevelsChange($event)">
                        </formly-form>
                      </div>

                      <!-- toolbar actions -->
                      <div class="btn-toolbar">
                        <button class="btn btn-primary ml-auto" (click)="updateMatchcriteria()">
                          <fa-icon [icon]="faSave"></fa-icon> {{'Save' | translate}}
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- tab match criteria matches -->
                  <div id="tab-matchcriteria-matches" class="tab-pane pt-3" [class.active]="activeMatchcriteriaTab() === 'matches'" [class.d-none]="activeMatchcriteriaTab() !== 'matches'">
                    @if (matchesLoading()) {
                    <app-loader></app-loader>
                    }

                    @if (!matchesLoading()) {
                    <div class="alert alert-info">
                      <fa-icon [icon]="faInfoCircle"></fa-icon>
                      {{'If you update the match criteria it can take up one day to get the correct (re-)calculated match results.' | translate}}
                    </div>
                    }

                    <!-- results -->
                    @if (matchesData().length > 0 && !matchesLoading()) {
                    <div class="results">
                      <div class="pb-2">{{ 'Matches' | translate }}: {{ matchesTotalItems() }}</div>

                      <div class="grid grid-network equal-height">
                        <div class="row">
                          @for (item of matchesData(); track item.id) {
                          <app-student-card class="col-12 col-lg-4 col-md-6 col-sm-6" [data]="item" [showMatchPercentage]="true"></app-student-card>
                          }
                        </div>
                      </div>

                      <ngb-pagination (pageChange)="matchesPageNumber.set($event); getMatches()" [page]="matchesPageNumber()" [pageSize]="matchesPageSize()" [collectionSize]="matchesTotalItems()"></ngb-pagination>
                    </div>
                    }

                    <!-- no results -->
                    @if (matchesData().length === 0 && !matchesLoading()) {
                    <div class="results results-none">
                      {{'No results' | translate}}
                    </div>
                    }
                  </div>

                  <!-- tab match criteria internationals -->
                  <div id="tab-matchcriteria-internationals" class="tab-pane pt-3" [class.active]="activeMatchcriteriaTab() === 'internationals'" [class.d-none]="activeMatchcriteriaTab() !== 'internationals'">
                    @if (internationalsLoading()) {
                    <app-loader></app-loader>
                    }

                    @if (!internationalsLoading()) {
                    <div class="alert alert-info">
                      <fa-icon [icon]="faInfoCircle"></fa-icon>
                      {{'If you update the match criteria it can take up one day to get the correct (re-)calculated match results.' | translate}}
                    </div>
                    }

                    <!-- results -->
                    @if (internationalsData().length > 0 && !internationalsLoading()) {
                    <div class="results">
                      <div class="pb-2">{{ 'Internationals' | translate }}: {{ internationalsTotalItems() }}</div>

                      <div class="grid grid-network equal-height">
                        <div class="row">
                          @for (item of internationalsData(); track item.id) {
                          <app-student-card class="col-12 col-lg-4 col-md-6 col-sm-6" [data]="item" [showMatchPercentage]="true"></app-student-card>
                          }
                        </div>
                      </div>

                      <ngb-pagination (pageChange)="internationalsPageNumber.set($event); getInternationalMatches()" [page]="internationalsPageNumber()" [pageSize]="internationalsPageSize()" [collectionSize]="internationalsTotalItems()"></ngb-pagination>
                    </div>
                    }

                    <!-- no results -->
                    @if (internationalsData().length === 0 && !internationalsLoading()) {
                    <div class="results results-none">
                      {{'No results' | translate}}
                    </div>
                    }
                  </div>
                </div>
              </div>

              <!-- tab dna -->
              @if (isDNAEnabled) {
              <div id="tab-profile-dna" class="tab-pane" [class.active]="activeTab() === 'dna'" [class.d-none]="activeTab() !== 'dna'">
                <h3 class="tab-pane">{{'DNA' | translate}}</h3>
              </div>
              }

              <!-- tab trade names -->
              <div id="tab-profile-tradenames" class="tab-pane" [class.active]="activeTab() === 'tradenames'" [class.d-none]="activeTab() !== 'tradenames'">
                <h3 class="tab-title">{{'Trade names' | translate}}</h3>

                <div class="btn-toolbar view-filter-toolbar-top mb-4">
                  <!-- sorting -->
                  <div class="input-group flex-grow-1">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        {{'Sort on' | translate}}
                      </span>
                    </div>
                    <select class="form-control custom-select">
                      @for (option of orderByOptions; track option.value) {
                      <option [value]="option.value">
                        {{option.label | translate}}
                      </option>
                      }
                    </select>
                    <select class="form-control custom-select">
                      @for (option of orderOptions; track option.value) {
                      <option [value]="option.value">
                        {{option.label | translate}}
                      </option>
                      }
                    </select>
                  </div>

                  <!-- search -->
                  <div class="input-group ml-4">
                    <input [ngModel]="trademarksFiltersSearch()" (ngModelChange)="trademarksFiltersSearch.set($event)" type="text" [placeholder]="'Search by title...' | translate" class="form-control" />
                    <div class="input-group-append">
                      <button class="btn btn-primary">
                        <fa-icon [icon]="faSearch"></fa-icon>
                      </button>
                    </div>
                  </div>

                  <button class="btn btn-primary ml-3" (click)="addTrademark()">
                    <fa-icon [icon]="faPlus"></fa-icon> {{'Trade name' | translate}}
                  </button>
                </div>

                <div class="results results-trademark">
                  @if (trademarksData().length > 0) {
                  <div class="grid">
                    <div class="row">
                      @for (trademark of trademarksData(); track trademark.id) {
                      <div class="col-12 col-lg-4 col-sm-6">
                        <div class="grid-item grid-item-network grid-item-network-company">
                          <div class="card">
                            <div [ngStyle]="{'background-image': 'url(' + trademark.coverPhotoUri +')' }" class="card-header grid-item-cover"></div>

                            <div class="card-body">
                              <div class="grid-item-profile-image">
                                <img class="card-img-top" [src]="(trademark.avatarUri ? trademark.avatarUri : avatarPlaceholder)" />
                              </div>
                              <h5 class="card-title grid-item-title">
                                {{trademark.name}}
                              </h5>
                            </div>

                            <div class="card-footer">
                              <button class="btn btn-danger btn-block text-center" (click)="deleteTrademark(trademark.id!)">
                                <fa-icon [icon]="faTimes"></fa-icon> {{'Delete' | translate}}
                              </button>
                              <button class="btn btn-outline-secondary btn-block text-center" (click)="updateTrademark(trademark)">
                                <fa-icon [icon]="faEdit"></fa-icon> {{'Edit' | translate}}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                  }
                </div>
              </div>

              <!-- tab experience day -->
              <div id="tab-profile-experienceday" class="tab-pane" [class.active]="activeTab() === 'experienceday'" [class.d-none]="activeTab() !== 'experienceday'">
                <ul class="nav nav-tabs">
                  <li class="nav-item">
                    <a class="nav-link cursor-pointer" [class.active]="activeExperiencedayTab() === 'myexperiencedays'" (click)="activeExperiencedayTab.set('myexperiencedays')">
                      {{'Follow-up days' | translate}}
                    </a>
                  </li>
                  <li>
                    <a class="nav-link cursor-pointer" [class.active]="activeExperiencedayTab() === 'registrations'" (click)="activeExperiencedayTab.set('registrations')">
                      {{'Follow-up day registrations' | translate}}
                    </a>
                  </li>
                </ul>

                <div class="tab-content">
                  <div id="tab-experienceday-myexperiencedays" class="tab-pane" [class.active]="activeExperiencedayTab() === 'myexperiencedays'" [class.d-none]="activeExperiencedayTab() !== 'myexperiencedays'">
                    <h3 class="tab-title">{{'Follow-up days' | translate}}</h3>

                    <!-- all company experience days container -->
                    <div class="card my-experiencedays">
                      <div class="card-header">
                        {{'My follow-up days' | translate}}
                      </div>
                      <div class="card-body">
                        <div class="btn-toolbar mb-3">
                          <button type="button" class="btn btn-primary ml-auto mr-0" (click)="addExperienceday()">
                            <fa-icon [icon]="faPlus"></fa-icon> {{'Add new' | translate}}
                          </button>
                        </div>

                        <!-- results -->
                        @if (experiencedaysData().length > 0) {
                        <table class="table table-striped">
                          <thead>
                            <tr>
                              <th>
                                {{'Title' | translate}}
                              </th>
                              <th>
                                {{'Status' | translate}}
                              </th>
                              <th>
                                {{'Amount of registrations' | translate}}
                              </th>
                              <th>
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            @for (experienceday of experiencedaysData(); track experienceday.id) {
                            <tr>
                              <td>
                                <h5 class="title">{{experienceday.title}}</h5>
                              </td>
                              <td>
                                {{experiencedayService.getStatusName(experienceday.status!) | translate}}
                              </td>
                              <td>
                                {{experienceday.numberOfRegistrations}}
                              </td>
                              <td>
                                <button class="btn btn-secondary btn-block btn-sm" (click)="updateExperienceday(experienceday)">
                                  <fa-icon [icon]="faEdit"></fa-icon> {{'Edit' | translate}}
                                </button>
                                <button class="btn btn-danger btn-block btn-sm" (click)="deleteExperienceday(experienceday.companyId!, experienceday.id!)">
                                  <fa-icon [icon]="faTimes"></fa-icon> {{'Delete' | translate}}
                                </button>
                              </td>
                            </tr>
                            }
                          </tbody>
                        </table>
                        }

                        <!-- no results -->
                        @if (experiencedaysData().length === 0) {
                        <div class="alert alert-info">
                          {{'No results' | translate}}
                        </div>
                        }
                      </div>
                    </div>
                  </div>

                  <div id="tab-experienceday-registrations" class="tab-pane" [class.active]="activeExperiencedayTab() === 'registrations'" [class.d-none]="activeExperiencedayTab() !== 'registrations'">
                    <h3 class="tab-title">{{'Follow-up day registrations' | translate}}</h3>

                    @if (plannedExperiencedaysData().length > 0) {
                    <div class="results">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>
                              {{'Follow-up day' | translate}}
                            </th>
                            <th>
                              {{'Student' | translate}}
                            </th>
                            <th>
                              {{'Date' | translate}}
                            </th>
                            <th>
                              {{'Attended' | translate}}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (node of plannedExperiencedaysData(); track node.id) {
                          <tr>
                            <td>
                              {{node.experienceDay?.title}}
                            </td>
                            <td>
                              <a [routerLink]="'/company/students/' + node.studentProfile?.id">
                                {{node.studentProfile?.firstName}} {{node.studentProfile?.lastName}}
                              </a>
                            </td>
                            <td>
                              {{node.date | date: "d-MM-YYYY"}}
                            </td>
                            <td>
                              <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" [checked]="node.hasAttended" [attr.id]="'hasAttended-' + node.id">
                                <label class="custom-control-label" [for]="'hasAttended-' + node.id" (click)="togglePlannedExperiencedayAttendancy(node)"></label>
                              </div>
                            </td>
                          </tr>
                          }
                        </tbody>
                      </table>

                      @if (plannedExperiencedaysTotalItems() > plannedExperiencedaysPageSize()) {
                        <div class="d-flex justify-content-center mt-3">
                          <ngb-pagination
                            (pageChange)="plannedExperiencedaysPageNumber.set($event); getCompanyPlannedExperiencedays(profile_id(), { PageNumber: $event, PageSize: plannedExperiencedaysPageSize() })"
                            [page]="plannedExperiencedaysPageNumber()"
                            [pageSize]="plannedExperiencedaysPageSize()"
                            [collectionSize]="plannedExperiencedaysTotalItems()">
                          </ngb-pagination>
                        </div>
                      }
                    </div>
                    }

                    @if (plannedExperiencedaysData().length === 0) {
                    <div class="alert alert-info no-results">
                      {{'No results' | translate}}
                    </div>
                    }
                  </div>
                </div>
              </div>

              <div id="tab-profile-elections" class="tab-pane" [class.active]="activeTab() === 'elections'" [class.d-none]="activeTab() !== 'elections'">
                <div class="alert alert-info">
                  <p>{{ 'To participate in an election you need to have or create an election admin account.' | translate}}</p>
                  @if (!isCompanyElectionAdmin()) {
                  <p class="m-0 p-0">
                    {{ 'It seems that your account is not yet a election administrator.' | translate }}<br />
                    {{ 'Follow these step to do so:' | translate}}<br>
                    {{ '1. Click the contact tab in the left menu' | translate}}<br>
                    {{ '2. Hit the button "make election admin" on one of your accounts and done!' | translate }}<br><br>
                    <span class="font-weight-bold text-xs">
                      {{ 'Note: it can take a while (max 1 day) before this account becomes an active election admin' | translate }}
                    </span>
                  </p>
                  }
                  @if (isCompanyElectionAdmin()) {
                  <p>
                    {{ 'Your account can subscribe to elections, please look at the elections below to subscribe to.' | translate }}
                  </p>
                  }
                </div>

                @if (elections().length > 0) {
                <h4>
                  {{ 'Current elections to participate in:' | translate }}
                </h4>

                <table class="table table-borderless">
                  <thead>
                    <tr>
                      <th></th>
                      <th>{{ 'Election' | translate }}</th>
                      <th>{{ 'Year' | translate}}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (election of elections(); track election.id) {
                    <tr>
                      <td>
                        <img class="img-32" [src]="election.avatarUri" />
                      </td>
                      <td class="w-50">
                        <p>{{ electionService.getTranslatedTitle(election) }}</p>
                        <div [innerHTML]="electionService.getTranslatedDescription(election)">
                        </div>
                      </td>
                      <td>
                        {{ election.year }}
                      </td>
                      <td>
                        @if (isCompanyElectionAdmin() && !election.isCurrentCompanyRegistered) {
                        <button class="btn btn-primary d-block w-100" type="button" (click)="signUpForElection(election)">
                          {{ 'Sign up' | translate }}
                        </button>
                        }
                        @if (isCompanyElectionAdmin() && election.isCurrentCompanyRegistered) {
                        <button class="btn btn-success d-block w-100" type="button">
                          <fa-icon [icon]="faCheck"></fa-icon>
                          {{ 'Signed up' | translate }}
                        </button>
                        <a class="btn btn-secondary d-block mt-2 w-100" target="_blank" [href]="awvlUrl">
                          <fa-icon [icon]="faExternalLink"></fa-icon>
                          {{ 'Go to election site' | translate }}
                        </a>
                        }
                      </td>
                    </tr>
                    }
                  </tbody>
                </table>
                }

                @if (elections().length === 0) {
                <div class="alert alert-info">
                  <p>{{ 'At the moment there are no active elections' | translate }}</p>
                </div>
                }
              </div>

              <!-- tab meetday scans -->
              <div id="tab-profile-meetday-scans" class="tab-pane" [class.active]="activeTab() === 'meetday-scans'" [class.d-none]="activeTab() !== 'meetday-scans'">
                <h3 class="tab-title">{{ 'Meetday scans' | translate }}</h3>

                <div class="mb-3">
                  <label class="font-weight-bold">{{ 'Select meetday' | translate }}</label>
                  <select class="form-control custom-select" [ngModel]="selectedMeetday()?.id" (ngModelChange)="onMeetdaySelection($event)">
                    @if (meetdayOptions().length === 0) {
                    <option [ngValue]="null">{{ 'No meetday data available yet.' | translate }}</option>
                    }
                    @for (meetday of meetdayOptions(); track meetday.id) {
                    <option [ngValue]="meetday.id">
                      {{ meetday.name }} - {{ meetday.date | date : 'mediumDate' }}
                    </option>
                    }
                  </select>
                </div>

                @if (meetdayScansLoading()) {
                <div class="text-center py-5">
                  <app-loader></app-loader>
                </div>
                }

                @if (!meetdayScansLoading()) {
                @if (!selectedMeetday() && meetdayOptions().length === 0) {
                <div class="alert alert-info">
                  {{ 'No meetday data available yet.' | translate }}
                </div>
                }
                @if (!selectedMeetday() && meetdayOptions().length > 0) {
                <div class="alert alert-info">
                  {{ 'Please select a meetday to view registered students.' | translate }}
                </div>
                }

                @if (selectedMeetday(); as currentMeetday) {
                <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-3">
                  <div>
                    <h4 class="mb-1">{{ currentMeetday.name }}</h4>
                    <small class="text-muted">
                      {{ 'Date' | translate }}: {{ currentMeetday.date | date : 'fullDate' }}
                    </small>
                  </div>
                </div>

                <!-- Search and Filter -->
                @if (currentMeetday.students.length > 0) {
                <div class="row mb-3">
                  <div class="col-md-6 mb-2 mb-md-0">
                    <input type="text" class="form-control" [placeholder]="'Search by name...' | translate" [ngModel]="meetdaySearchTerm()" (ngModelChange)="meetdaySearchTerm.set($event)">
                  </div>
                  <div class="col-md-6">
                    <select class="form-control custom-select" [ngModel]="meetdayScanFilter()" (ngModelChange)="meetdayScanFilter.set($event)">
                      <option value="all">{{ 'All Students' | translate }}</option>
                      <option value="scanned">{{ 'Present' | translate }}</option>
                      <option value="notScanned">{{ 'Not present' | translate }}</option>
                    </select>
                  </div>
                </div>
                }

                @if (currentMeetday.students.length === 0) {
                <div class="alert alert-info">
                  {{ 'No students have registered for this meetday yet.' | translate }}
                </div>
                }

                @if (currentMeetday.students.length > 0 && filteredMeetdayStudents().length === 0) {
                <div class="alert alert-info">
                  {{ 'No students match your search criteria.' | translate }}
                </div>
                }

                @if (filteredMeetdayStudents().length > 0) {
                <div class="grid equal-height grid-network">
                  <div class="row">
                    @for (student of filteredMeetdayStudents(); track student.id) {
                    <app-student-card class="col-12 col-lg-4 col-md-6 col-sm-6" [data]="student" [showMatchPercentage]="false" [confirmedAttendance]="student.confirmedAttendance"></app-student-card>
                    }
                  </div>
                </div>
                }
                }
                }
              </div>

              <!-- tab contact -->
              <div id="tab-profile-contact" class="tab-pane" [class.active]="activeTab() === 'contact'" [class.d-none]="activeTab() !== 'contact'">
                <!-- contact details -->
                <div class="contact-details">
                  <h3>{{'Contact details'}}</h3>

                  <div id="validation-errors">
                    @if (errors()['street']) {
                    <div class="alert alert-danger validation-error">
                      <p>{{'Please fill in your street name' | translate}}</p>
                    </div>
                    }

                    @if (errors()['street']) {
                    <div class="alert alert-danger validation-error">
                      <p>{{'Please fill in your street number' | translate}}</p>
                    </div>
                    }

                    @if (errors()['city']) {
                    <div class="alert alert-danger validation-error">
                      <p>{{'Please fill in your city' | translate}}</p>
                    </div>
                    }

                    @if (errors()['postalCode']) {
                    <div class="alert alert-danger validation-error">
                      <p>{{'Please fill in your postal code' | translate}}</p>
                    </div>
                    }

                    @if (errors()['country']) {
                    <div class="alert alert-danger validation-error">
                      <p>{{'Please select your country' | translate}}</p>
                    </div>
                    }
                  </div>

                  <div class="form-group">
                    <label>{{'Phone number' | translate}}</label>
                    <input type="text" class="form-control" [ngModel]="entity().phoneNumber" (ngModelChange)="updateEntityField('phoneNumber', $event)" />
                  </div>

                  <div class="form-group">
                    <label>{{'Website' | translate}}</label>
                    <input type="text" class="form-control" [ngModel]="entity().websiteUri" (ngModelChange)="updateEntityField('websiteUri', $event)" />
                  </div>

                  <div class="form-group">
                    <label>{{'Sector' | translate}}</label>
                    <select type="text" class="form-control" [ngModel]="entity().sectorId" (ngModelChange)="updateEntitySector($event)">
                      <option value="null"></option>
                      @for (option of areaOfInterestsFiltered(); track option.value) {
                      <option [value]="option.value" [selected]="option.value === entity().sectorId">
                        {{option.label}}
                      </option>
                      }
                    </select>
                  </div>

                  <div class="form-group">
                    <label>{{'Number of employees' | translate}}</label>
                    <input type="text" class="form-control" [ngModel]="entity().numberOfEmployees" (ngModelChange)="updateEntityField('numberOfEmployees', $event)" />
                  </div>

                  <h4 class="">{{'Address' | translate}}</h4>

                  @if (entity().visitAddress) {
                  <div class="row">
                    <div class="col-12 col-sm-8">
                      <div class="form-group">
                        <label>{{'Street' | translate}}*</label>
                        <input required type="text" class="form-control" name="address-line1" autocomplete="address-line1" [ngModel]="entity().visitAddress!.street" (ngModelChange)="updateEntityVisitAddress('street', $event)" />
                      </div>
                    </div>

                    <div class="col-8 col-sm-2">
                      <div class="form-group">
                        <label>{{'No.' | translate}}*</label>
                        <input required type="text" class="form-control" name="address-line2" autocomplete="address-line2" [ngModel]="entity().visitAddress!.number" (ngModelChange)="updateEntityVisitAddress('number', $event)" />
                      </div>
                    </div>

                    <div class="col-4 col-sm-2">
                      <div class="form-group">
                        <label>{{'Addition' | translate}}</label>
                        <input type="text" class="form-control" autocomplete="off" [ngModel]="entity().visitAddress!.numberSuffix" (ngModelChange)="updateEntityVisitAddress('numberSuffix', $event)" />
                      </div>
                    </div>

                    <div class="col-8 col-sm-8">
                      <div class="form-group">
                        <label>{{'City' | translate}}*</label>
                        <input type="text" class="form-control" name="city" autocomplete="address-level2" [ngModel]="entity().visitAddress!.city" (ngModelChange)="updateEntityVisitAddress('city', $event)" />
                      </div>
                    </div>

                    <div class="col-4 col-sm-4">
                      <div class="form-group">
                        <label>{{'Postal code' | translate}}*</label>
                        <input required type="text" class="form-control" name="postal-code" autocomplete="postal-code" [ngModel]="entity().visitAddress!.postalCode" (ngModelChange)="updateEntityVisitAddress('postalCode', $event)" />
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="form-group">
                        <label>{{'Country' | translate}}*</label>
                        <select required class="form-control" name="country" autocomplete="country" [ngModel]="entity().visitAddress!.country" (ngModelChange)="updateEntityVisitAddress('country', $event)">
                          @for (option of locale.availableCountries(); track option.code) {
                          <option [value]="option.code">
                            {{option.name}}
                          </option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                  }

                  <h4>{{'Social media' | translate}}</h4>

                  <div class="form-group">
                    <label>X (Twitter) {{'link' | translate}}</label>
                    <input type="text" class="form-control" [ngModel]="entity().twitterUri" (ngModelChange)="updateEntityField('twitterUri', $event)" />
                  </div>

                  <div class="form-group">
                    <label>Facebook {{'link' | translate}}</label>
                    <input type="text" class="form-control" [ngModel]="entity().facebookUri" (ngModelChange)="updateEntityField('facebookUri', $event)" />
                  </div>

                  <div class="form-group">
                    <label>LinkedIn {{'link' | translate}}</label>
                    <input type="text" class="form-control" [ngModel]="entity().linkedInUri" (ngModelChange)="updateEntityField('linkedInUri', $event)" />
                  </div>

                  <div class="form-group">
                    <label>Instagram {{'link' | translate}}</label>
                    <input type="text" class="form-control" [ngModel]="entity().instagramUri" (ngModelChange)="updateEntityField('instagramUri', $event)" />
                  </div>

                  <div class="form-group">
                    <label>Google {{'link' | translate}}</label>
                    <input type="text" class="form-control" [ngModel]="entity().googleUri" (ngModelChange)="updateEntityField('googleUri', $event)" />
                  </div>

                  <div class="btn-toolbar">
                    <button class="btn btn-primary ml-auto" (click)="UpdateCompanyProfile()">
                      {{'Save' | translate}}
                    </button>
                  </div>
                </div>

                <!-- company accounts -->
                <div class="company-accounts">
                  <h3>{{'Accounts' | translate}}</h3>

                  <div class="btn-toolbar mb-3">
                    <button class="btn btn-primary ml-auto" (click)="addCompanyAccount()">
                      <fa-icon [icon]="faPlus"></fa-icon> {{'Account' | translate}}
                    </button>
                  </div>

                  <div class="results results-company-accounts">
                    @if (accountsData().length > 0) {
                    <div class="grid grid-company-account">
                      <div class="row">
                        @for (account of accountsData(); track account.accountId) {
                        <div class="col-12 col-lg-4">
                          <div class="grid-item grid-item-network grid-item-network-company-account">
                            <div class="card">
                              <div class="card-body">
                                <div class="grid-item-heading">
                                  <h5 class="card-title grid-item-title">
                                    {{account.account?.firstName}} {{account.account?.lastName}}
                                  </h5>
                                </div>

                                <div class="grid-item-profile-image">
                                  <img class="card-img-top" [src]="account.account?.avatarUri ? account.account?.avatarUri : avatarAccountPlaceholder" />
                                </div>

                                <p class="emailaddress mt-3">
                                  <a class="" [href]="'mailto:' + account.account?.emailAddress">
                                    <fa-icon [icon]="faEnvelope"></fa-icon> {{account.account?.emailAddress}}
                                  </a>
                                </p>

                                @if (account.account?.phoneNumber) {
                                <p class="phone mt-3">
                                  <a [href]="'tel:' + account.account?.phoneNumber">
                                    <fa-icon [icon]="faPhone"></fa-icon> {{account.account?.phoneNumber}}
                                  </a>
                                </p>
                                }
                              </div>

                              <div class="card-footer">
                                <div class="btn-toolbar">
                                  @if (account.account?.roles && !account.account?.roles?.includes(RoleTypes.BedrijfsVerkiezingsbeheerder)) {
                                  <button class="btn btn-sm btn-outline-primary btn-block" (click)="makeCompanyAccountCompanyElectionOwner(profile_id(), account.accountId!)">
                                    {{ 'Make election admin' | translate }}
                                  </button>
                                  }

                                  @if (account.account?.roles?.includes(RoleTypes.BedrijfsVerkiezingsbeheerder)) {
                                  <button class="btn btn-sm btn-outline-primary btn-block" (click)="removeCompanyAccountCompanyElectionOwnerRole(profile_id(), account.accountId!)">
                                    {{ 'Undo election admin' | translate }}
                                  </button>
                                  }

                                  <button (click)="deleteCompanyAccount(entity().id!, account.account?.id!)" class="btn btn-outline-danger btn-block">
                                    {{'Delete' | translate}}
                                  </button>

                                  <button (click)="updateCompanyAccount(account)" class="btn btn-outline-primary btn-block d-none">
                                    {{'Edit' | translate}}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        }
                      </div>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
}
